

















import Vue, { PropType } from "vue";

export default Vue.extend({
  props: {
    loading: { type: Boolean, required: true },
    inputName: { type: String, required: true },
    clickEvent: { type: Function as PropType<() => void>, required: true },
  },
});
